// atlas-shopify-bridge.js
// Connects the prototype's localStorage cart to Shopify's real cart,
// and replaces the mock product catalog with live Shopify products.

(function(){
  const CART_KEY = 'atlas_cart_v1';

  function detectCat(name){
    const s = (name || '').toLowerCase();
    if (/earring|hoop|stud/.test(s)) return 'earrings';
    if (/necklace|pendant|chain/.test(s)) return 'necklaces';
    if (/bracelet|bangle|beads?/.test(s)) return 'bracelets';
    if (/ring|cuff|signet|band/.test(s)) return 'rings';
    return 'rings';
  }

  // ── Replace mock products with live Shopify products ──
  if (window.ATLAS_PRODUCTS_LIVE && window.ATLAS_PRODUCTS_LIVE.length > 0 && window.ATLAS_DATA) {
    window.ATLAS_DATA.products = window.ATLAS_PRODUCTS_LIVE.map(function(p){
      const cat = detectCat(p.name);
      const variants = p.variants || [];
      // Total stock = sum across variants
      const stock = variants.reduce(function(s,v){ return s + Math.max(v.qty || 0, 0); }, 0);
      const availableVariants = variants.filter(function(v){ return v.available; });
      const anyAvailable = availableVariants.length > 0 || p.available;
      const defaultVariant = availableVariants[0] || variants[0];
      return {
        id: p.handle,
        name: p.name,
        description: p.description || '',
        price: typeof p.price === 'number' ? p.price : parseFloat(p.price) || 0,
        cat: cat,
        status: !anyAvailable ? 'sold_out' : (stock > 0 && stock < 5 ? 'low' : 'in_stock'),
        stock: Math.max(stock, 0),
        sku: (p.handle || '').toUpperCase(),
        image: p.image,
        images: p.images || [],
        options: p.options || [],
        variants: variants,
        variantId: defaultVariant ? defaultVariant.id : null,
        shopifyHandle: p.handle,
      };
    });

    // Update category counts to reflect real products
    if (window.ATLAS_DATA.categories) {
      window.ATLAS_DATA.categories.forEach(function(c){
        c.count = window.ATLAS_DATA.products.filter(function(p){ return p.cat === c.slug; }).length;
      });
    }
  }

  // Map prototype product id → default variant id (fallback when cart line has no variantId)
  const variantMap = {};
  ((window.ATLAS_DATA && window.ATLAS_DATA.products) || []).forEach(function(p){
    if (p.variantId) variantMap[p.id] = p.variantId;
  });

  // ── Sync localStorage cart → Shopify cart ──
  let syncing = false;
  let pendingResolvers = [];

  async function syncCart(){
    if (syncing) {
      return new Promise(function(resolve){ pendingResolvers.push(resolve); });
    }
    syncing = true;
    try {
      const local = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
      const items = local
        .map(function(line){
          const vid = line.variantId || variantMap[line.pid];
          if (!vid) return null;
          return { id: vid, quantity: line.qty };
        })
        .filter(Boolean);

      await fetch('/cart/clear.js', { method: 'POST' });

      if (items.length > 0) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          console.warn('[atlas] /cart/add.js failed', await res.text());
        }
      }
    } catch (e) {
      console.error('[atlas] cart sync failed:', e);
    } finally {
      syncing = false;
      const resolvers = pendingResolvers;
      pendingResolvers = [];
      resolvers.forEach(function(r){ r(); });
    }
  }

  let syncTimer;
  function scheduleSync(){
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, 350);
  }

  window.addEventListener('atlas-cart-change', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(syncCart, 100); });
  } else {
    setTimeout(syncCart, 100);
  }

  // Intercept checkout navigation — flush sync before leaving
  document.addEventListener('click', async function(e){
    const a = e.target.closest && e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
    if (!a || a.dataset.atlasFlushed === '1') return;
    e.preventDefault();
    a.dataset.atlasFlushed = '1';
    await new Promise(function(r){ setTimeout(r, 360); });
    await syncCart();
    window.location.href = a.getAttribute('href');
  }, true);

  window.atlasSyncCart = syncCart;
})();
